module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BasePage', {
    attrs: {
      "title": "Settings"
    }
  }, [(_vm.loading) ? _c('Loader') : _c('section', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-10-tablet is-offset-1-tablet is-8-desktop is-offset-2-desktop is-6-fullhd is-offset-3-fullhd"
  }, [_c('h2', {
    staticClass: "title is-2 pt-0 mt-0"
  }, [_vm._v("Settings")]), _vm._v(" "), _c('section', {
    staticClass: "d-flex"
  }, [_c('div', [_c('figure', {
    staticClass: "image is-96x96"
  }, [_c('img', {
    attrs: {
      "src": _vm.avatarURL
    }
  })]), _vm._v(" "), _c('figcaption', {
    staticClass: "text-center"
  }, [_vm._v("\n            change at "), _c('a', {
    attrs: {
      "href": "http://en.gravatar.com/support/activating-your-account/"
    }
  }, [_vm._v("gravatar")])])]), _vm._v(" "), _c('section', {
    staticClass: "ml-5 grow-1"
  }, [_c('SettingsProfileField', {
    attrs: {
      "title": 'display name',
      "value": _vm.name,
      "placeholder": 'Jane Doe',
      "save": _vm.saveName
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "fs-6"
  }, [_vm._v("email address")]), _vm._v(" "), _c('h3', {
    staticClass: "title is-4 mb-1"
  }, [_vm._v(_vm._s(_vm.email))])], 1)]), _vm._v(" "), _c('label', {
    staticClass: "fs-6"
  }, [_vm._v("classforward birthday")]), _vm._v(" "), _c('h3', {
    staticClass: "title is-4 mb-1"
  }, [_vm._v(_vm._s(_vm._f("formatTextDate")(_vm.bday)))]), _vm._v(" "), _c('SettingsProfileField', {
    staticClass: "mt-3",
    attrs: {
      "title": 'content area',
      "value": _vm.contentArea,
      "placeholder": 'Mathematics',
      "save": _vm.saveContentArea
    }
  }), _vm._v(" "), _c('SettingsProfileField', {
    staticClass: "mt-3",
    attrs: {
      "title": 'position',
      "value": _vm.position,
      "placeholder": 'Teacher',
      "save": _vm.savePosition
    }
  }), _vm._v(" "), _c('SettingsProfileField', {
    staticClass: "mt-3",
    attrs: {
      "title": 'school',
      "value": _vm.school,
      "placeholder": 'Anytown High',
      "save": _vm.saveSchool
    }
  }), _vm._v(" "), _c('SettingsProfileField', {
    staticClass: "mt-3",
    attrs: {
      "title": 'grade',
      "value": _vm.grade,
      "placeholder": '8',
      "save": _vm.saveGrade
    }
  }), _vm._v(" "), (!_vm.isPro) ? _c('section', [_c('label', {
    staticClass: "fs-6"
  }, [_vm._v("license")]), _vm._v(" "), _c('h3', {
    staticClass: "title is-4 mb-1 d-flex align-items-center"
  }, [_c('div', {
    staticClass: "activated-circle"
  }), _vm._v("\n          Activated"), (_vm.expiresOn) ? _c('span', [_vm._v(" through " + _vm._s(_vm._f("formatTextDate")(_vm.expiresOn)))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "title is-3 mb-2 mt-4"
  }, [_vm._v("Login")]), _vm._v(" "), (_vm.hasUsablePassword) ? _c('router-link', {
    attrs: {
      "to": "/change-password"
    }
  }, [_vm._v("Change password")]) : _c('router-link', {
    attrs: {
      "to": "/set-password"
    }
  }, [_vm._v("Set password")]), _vm._v(" "), _c('h2', {
    staticClass: "title is-3 mb-2 mt-4"
  }, [_vm._v("Social Login")]), _vm._v(" "), _c('SocialConnect', {
    attrs: {
      "accounts": _vm.socialAccounts
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "title is-3 mb-2 mt-4"
  }, [_vm._v("Email Notifications")]), _vm._v(" "), _c('EmailSettingField', {
    attrs: {
      "description": 'Send me an email when videos are shared with me:',
      "value": _vm.emailEnabled,
      "save": _vm.setEmailNotifications
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-14eb26e5"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings.vue
// module id = 986
// module chunks = 0